import React from 'react'
import BlogCard from '../components/BlogCard'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const Blog = () => {
  return (
    <>
        <Meta title='Blogs' />
        <BreadCrum title='Blogs' />
        <Container class1="blog-wrapper home-wrapper-2 py-3">
            <div className="row">
                <div className="col-3">
                    <div className="filter-card mb-3">
                        <h3 className="filter-title">Find By Categories</h3>
                        <div>
                            <ul className="ps-0">
                                <li>Watch</li>
                                <li>TV</li>
                                <li>Camera</li>
                                <li>Laptop</li>
                            </ul>
                        </div>             
                    </div>
                </div>
                <div className="col-9">
                    <div className="row mb-2">
                        <div className="col-6">
                            <BlogCard />
                        </div>
                        <div className="col-6">
                            <BlogCard />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <BlogCard />
                        </div>
                        <div className="col-6">
                            <BlogCard />
                        </div>
                    </div>
                </div>
            </div>

        </Container>
    </>
  )
}

export default Blog